import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiTrash2 } = FiIcons;

function TaskItem({ task, onToggle, onDelete }) {
  return (
    <motion.article
      className={`task-card ${task.done ? 'is-done' : ''}`}
      layout
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, x: 30 }}
    >
      <button
        className="check"
        onClick={() => onToggle(task.id)}
        aria-label={`Mark ${task.title} as ${task.done ? 'incomplete' : 'complete'}`}
      >
        {task.done && <SafeIcon icon={FiCheck} />}
      </button>

      <div className="task-copy">
        <p>{task.title}</p>
        <div className="task-meta">
          <span className={`priority-dot priority-${task.priority}`} />
          <span className="category-chip">{task.category}</span>
        </div>
      </div>

      <button className="delete" onClick={() => onDelete(task.id)} aria-label={`Delete ${task.title}`}>
        <SafeIcon icon={FiTrash2} />
      </button>
    </motion.article>
  );
}

export default TaskItem;